import { Injectable } from '@angular/core';
import { FiBackendService } from '../../shared/fi-backend/fi-backend.service';
import { IADGroupMapping } from './group-mapping/group-mapping-definitions';

export interface ISaveGroupMappingsDataItem {
    GroupId: string;
    ObjectType: number;
    ObjectId?: number;
    Id?: number;
}

export type ISaveGroupMappingsData = ISaveGroupMappingsDataItem[];

@Injectable()
export class FiADIntegrationService {
    constructor(private backend: FiBackendService) {}

    ImportAdGroups(adGroupGuids: string[]) {
        return this.backend.fetchDataPost<any>('ADIntegration/ADIntegration/ImportAdGroups', adGroupGuids);
    }

    GetGroupMappings() {
        return this.backend.fetchData<IADGroupMapping[]>('ADIntegration/ADIntegration/GetGroupMappings');
    }

    SaveGroupMappings(data: ISaveGroupMappingsData) {
        return this.backend.fetchDataPost('ADIntegration/ADIntegration/SaveGroupMappings', data);
    }

    GetAdGroupsForImportFiltering() {
        return this.backend.fetchData<ILightWeightADGroup[]>(
            'ADIntegration/ADIntegration/GetAdGroupsForImportFiltering',
        );
    }
}
